import React, { useContext, useState, useEffect } from 'react';
import { Button, Form, Icon } from 'semantic-ui-react';
import InputText from '../../FormInputCustomer/InputText/InputText';
import CheckPassword from '../../CheckPassword/CheckPassword';
import GlobalContext from '../../../contexts/GlobalContext';
import { toast } from 'react-toastify';
import Utility from '../../../Utility';
import ModalTransition from '../../ModalTransition/ModalTransition';

const ModalAccount = props => {
  const [globalContext] = useContext(GlobalContext);
  const [newPasswordState, setNewPasswordState] = useState('');
  const [confirmPasswordState, setConfirmPasswordState] = useState('');
  const [isOpenState, setIsOpenState] = useState(true);
  const [errorState, setErrorState] = useState(true);
  const [typeInputNewPasswordState, setTypeInputNewPasswordState] = useState('password');
  const [typeInputConfirmPasswordState, setTypeInputConfirmPasswordState] = useState('password');

  const initListError = () => {
    let listInput = getListInput();
    let error = {};
    
    for (let index in listInput) {// eslint-disable-line no-unused-vars
      let input = listInput[index];
      error[input.name] = false;
    }
    return error;
  }

  const handleClickShowPassword = (event) => {
    let name = event.target.closest('div.input').querySelector('input').name;
    if (name === 'input_newPassword') {
      setTypeInputNewPasswordState('text');
      let timeOutShowNewPassword = setTimeout(() => {
        setTypeInputNewPasswordState('password');
        window.clearTimeout(timeOutShowNewPassword);
      }, 1500);
    } else if (name === 'input_confirmPassword') {
      setTypeInputConfirmPasswordState('text');
      let timeOutShowConfirmPassword = setTimeout(() => {
        setTypeInputConfirmPasswordState('password');
        window.clearTimeout(timeOutShowConfirmPassword);
      }, 1500);
    }
  }

  const handleCloseModal = () => {
    document.body.classList.remove('modal-fade-in');
    setIsOpenState(false)
    props.close(props.typeModal)
  }

  const handleClickValid = (event) => {
    const listError = initListError();
    let dataForm = new FormData(event.target.closest('.modal').querySelector('form')),
      error = false,
      listInput = getListInput(),
      listInputCheckValue = {};

    if (props.typeModal === 'changePassword') {
      listInputCheckValue = {
        [listInput.oldPassword.name]: Utility.checkValue(listInput.oldPassword.name, dataForm.get('input_password'), listInput.oldPassword.typePattern),
        [listInput.password.name]: Utility.checkValue(listInput.password.name, dataForm.get('input_newPassword'), listInput.password.typePattern),
        [listInput.confirmPassword.name]: Utility.checkValue(listInput.confirmPassword.name, dataForm.get('input_confirmPassword'), listInput.confirmPassword.typePattern)
      }

      if (listInputCheckValue[listInput.oldPassword.name].error === true) {
        error = true;
        listError[listInput.oldPassword.name] = true;
      }
      if (listInputCheckValue[listInput.password.name].error === true) {
        error = true;
        listError[listInput.password.name] = true;
      }
      if (listInputCheckValue[listInput.confirmPassword.name].error === true) {
        error = true;
        listError[listInput.confirmPassword.name] = true;
      }
      if (error === false) {
        if (listInputCheckValue[listInput.password.name].value !== listInputCheckValue[listInput.confirmPassword.name].value) {
          error = true;
          listError[listInput.password.name] = true;
          listError[listInput.confirmPassword.name] = true;
          toast.error(globalContext.translations.msgErrorChangePassWordNonIdentique);
        } else if (listInputCheckValue[listInput.oldPassword.name].value === listInputCheckValue[listInput.password.name].value) {
          error = true;
          listError[listInput.oldPassword.name] = true;
          listError[listInput.password.name] = true;
          listError[listInput.confirmPassword.name] = true;
          toast.error(globalContext.translations.msgErrorChangeNewPassWordEgaleOldPassWord);
        }
      }
    } else if (props.typeModal === 'changeEmail') {
      listInputCheckValue = {
        [listInput.email.name]: Utility.checkValue(listInput.email.name, dataForm.get('input_email'), listInput.email.typePattern),
        [listInput.password.name]: Utility.checkValue(listInput.password.name, dataForm.get('input_password'), listInput.password.typePattern)
      }

      if (listInputCheckValue[listInput.email.name].error === true) {
        error = true;
        listError[listInput.email.name] = true;
      }
      if (listInputCheckValue[listInput.password.name].error === true) {
        error = true;
        listError[listInput.password.name] = true;
      }
    }

    if (error === false) {
      props.valid(props.typeModal, dataForm);
      handleCloseModal();
    } else {
      setErrorState(listError);
      setNewPasswordState('');
      setConfirmPasswordState('');
    }
  }

  const handleValueNewPassWord = (name, value) => {
    setNewPasswordState(value);
  }

  const handleValueConfirmPassword = (name, value) => {
    setConfirmPasswordState(value);
  }

  const getListInput = () => {
    if (props.typeModal === 'changeEmail') {
      return {
        email: {
          name: 'email',
          required: true,
          typePattern: 'email',
          valueDefault: ''
        },
        password: {
          name: 'password',
          required: true,
          typePattern: 'notNull',
          valueDefault: ''
        },
      }
    } else {
      return {
        oldPassword: {
          name: 'password',
          required: true,
          typePattern: 'notNull',
          valueDefault: ''
        },
        password: {
          name: 'newPassword',
          required: true,
          typePattern: 'password',
          valueDefault: ''
        },
        confirmPassword: {
          name: 'confirmPassword',
          required: true,
          typePattern: 'password',
          valueDefault: ''
        }
      }
    }
  }

  const getContent = () => {
    if (props.typeModal === 'changeEmail') {
      return getContentEmail();
    } else {
      return getContentPassword();
    }
  }

  const getContentEmail = () => {
    let listInput = getListInput();

    return (
      <Form.Group widths="equal">
        <InputText
          label={globalContext.translations.emailEspaceClient}
          name={listInput.email.name}
          required={listInput.email.required}
          typePattern={listInput.email.typePattern}
          placeholder={globalContext.user.mail}
          value="" //set à vide pour la modal de changement d'adresse
          type="email"
          error={errorState.email}
          labelError={globalContext.translations.newEmaildRequired}
        />
        <InputText
          type="password"
          label={globalContext.translations.password}
          name={listInput.password.name}
          required={listInput.password.required}
          typePattern={listInput.password.typePattern}
          error={errorState.password}
          labelError={globalContext.translations.passwordRequired}
        />
      </Form.Group>
    )
  }

  const getContentPassword = () => {
    let listInput = getListInput();
    return (
      <div>
        <Form.Group widths="equal">
          <InputText
            type="password"
            label={globalContext.translations.oldPassword}
            name={listInput.oldPassword.name}
            required={listInput.oldPassword.required}
            typePattern={listInput.oldPassword.typePattern}
            labelError={globalContext.translations.passwordNowRequired}
            error={errorState[listInput.oldPassword.name]}
          />
        </Form.Group>
        <Form.Group widths="equal">
          <InputText
            type={typeInputNewPasswordState}
            label={globalContext.translations.newPassword}
            name={listInput.password.name}
            required={listInput.password.required}
            typePattern={listInput.password.typePattern}
            icon={<Icon name="eye" link onClick={handleClickShowPassword} />}
            error={errorState[listInput.password.name]}
            handleChange={handleValueNewPassWord}
            value={newPasswordState}
          />
          <InputText
            type={typeInputConfirmPasswordState}
            label={globalContext.translations.confirmNewPassword}
            name={listInput.confirmPassword.name}
            required={listInput.confirmPassword.required}
            typePattern={listInput.confirmPassword.typePattern}
            icon={<Icon name="eye" link onClick={handleClickShowPassword} />}
            error={errorState[listInput.confirmPassword.name]}
            handleChange={handleValueConfirmPassword}
            value={confirmPasswordState}
          />
        </Form.Group>
        <CheckPassword password={newPasswordState} translations={{
          contentPasswordUpperCase: globalContext.translations.contentPasswordUpperCase,
          contentPasswordLowerCase: globalContext.translations.contentPasswordLowerCase,
          contentPasswordNumberCase: globalContext.translations.contentPasswordNumberCase,
          contentPasswordMinCharsCase: globalContext.translations.contentPasswordMinCharsCase,
          contentPassword: globalContext.translations.contentPassword
        }} />
      </div>
    )
  }

  return (
    <ModalTransition
      size="small"
      open={isOpenState}
      handleClose={handleCloseModal}
      header={globalContext.translations[props.typeModal]}
      content={
        <Form>
          {getContent()}
        </Form>
      }
      actions={
        <div>
          <Button
            color="grey"
            icon="cancel"
            labelPosition="right"
            content={globalContext.translations.preCheckInCancel}
            onClick={handleCloseModal}
            />
          <Button
            positive
            icon="checkmark"
            labelPosition="right"
            content={globalContext.translations.save}
            onClick={handleClickValid}
          />
        </div>
      }
    />
  )
}

export default ModalAccount;